import React ,{ useState } from "react" ;
import { useNavigate  } from "react-router-dom";
import './Intro.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import KycShell from '../../components/KycShell';


const brandname = localStorage.getItem('brandname');

const Intro = () => {

	const [btn , setbtn] = useState("btn btn-primary");
	const [btntxt , setbtntxt] = useState("Continue");
	const [btnicon , setbtnicon] = useState("fa-solid fa-arrow-right");
	const brandlogo = localStorage.getItem('brandlogo');

    const navigate = useNavigate();



    const nextpage= ()=>{
		setbtntxt("");
		setbtn("btn btn-success");
		setbtnicon("fa-solid fa-check");

		const isalreadycheck = localStorage.getItem('isalreadycheck');

		const kyctype = localStorage.getItem('kyctype');

		if(kyctype === 'partial')
		{
			const partial_page = localStorage.getItem('partial_page');
			if(partial_page === 'LIVENESS')
			{
				setTimeout(function(){	navigate('/liveness') }, 500);
			}else if(partial_page === 'ID')
			{
				setTimeout(function(){	navigate('/personal') }, 500);
			}else if(partial_page === 'ADDRESS')
			{
				setTimeout(function(){	navigate('/proof') }, 500);
			}

		}else{
			if(isalreadycheck == 0)
			{
				setTimeout(function(){	navigate('/kycalready') }, 500);
			}else{
				setTimeout(function(){	navigate('/personal') }, 500);
			}
		}

    }
    return(
		<KycShell step={0} brandName={brandname}>
			<div className="kyc-card">
				<div className="kyc-card__eyebrow">Identity verification</div>
				<h1 className="kyc-card__title">
					To continue, we need to verify your identity
				</h1>
				<p className="kyc-card__subtitle">
					The process takes only a few minutes. Please prepare a valid
					identity document and agree to the processing of your personal data.
				</p>

				<div className="kyc-card__section" style={{ marginTop: 4 }}>
					<div className="kyc-feature">
						<div className="kyc-feature__icon">
							<i className="fa fa-bolt" aria-hidden="true"></i>
						</div>
						<div>
							<p className="kyc-feature__title">Fast &amp; encrypted</p>
							<p className="kyc-feature__text">
								Verification usually takes less than a few minutes and is fully encrypted.
							</p>
						</div>
					</div>
					<div className="kyc-feature">
						<div className="kyc-feature__icon">
							<i className="fa fa-lock" aria-hidden="true"></i>
						</div>
						<div>
							<p className="kyc-feature__title">Your data is protected</p>
							<p className="kyc-feature__text">
								Read our service provider's <a href="" style={{ color: 'var(--kyc-accent)', fontWeight: 600 }}>privacy statement</a> to learn how data is handled.
							</p>
						</div>
					</div>
				</div>

				<button className="btn_continue" onClick={nextpage} style={{ marginTop: 8 }}>
					{btntxt || 'Start KYC'}
					<i className={btnicon} style={{ marginLeft: 8 }}></i>
				</button>
			</div>
		</KycShell>
    );
};
export default Intro;
